import { InputHTMLAttributes, forwardRef } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { label, error, helperText, fullWidth = false, className = "", ...rest },
    ref
  ) => {
    const inputBaseClasses =
      "input input-bordered w-full transition-all duration-200";
    const inputErrorClasses = error ? "input-error border-error" : "";
    const inputClasses =
      `${inputBaseClasses} ${inputErrorClasses} ${className} outline-none`.trim();

    return (
      <div className={`form-control ${fullWidth ? "w-full" : ""}`}>
        {label && (
          <label className="label">
            <span className="label-text font-medium text-base-content">
              {label}
            </span>
          </label>
        )}
        <input ref={ref} className={inputClasses} {...rest} />
        {error && (
          <label className="label">
            <span className="label-text-alt text-error text-xs">{error}</span>
          </label>
        )}
        {helperText && !error && (
          <label className="label">
            <span className="label-text-alt text-base-content/60 text-xs">
              {helperText}
            </span>
          </label>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
